import { Component, OnInit } from '@angular/core';
import { PasswordRecoveryService } from '../password-recovery.service';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css']
})
export class ForgotPasswordComponent implements OnInit {

  recoveryIdentifierx = "";
  error = "";
  success = "";

  constructor(private passwordRecoveryService: PasswordRecoveryService) { }

  ngOnInit(): void {
  }

  onSubmit() {
    this.error = "";
    this.passwordRecoveryService.recoverPw(this.recoveryIdentifierx).subscribe(()=>{
      this.success = "Please check your email for link to recover your email.";
    }, (error) => {
      if (error.error instanceof ErrorEvent) {
        this.error = `Error finding user${error.error.message ? ': ' + error.error.message : ''}`;
      } else {
        this.error = `Error finding user${error.error ? ': ' + error.error : ''}`;
      }
    });
  }

}
